class DelSolManifesto extends HTMLElement {
  connectedCallback() {
    if (this._connected) return;

    this.video = this.querySelector('video');
    if (!this.video) return;

    this._connected = true;
    this._isIntersecting = false;
    this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this._onMotionChange = () => this.syncPlayback();
    this._onPlaying = () => {
      this.classList.add('is-playing');
      this.removeAttribute('data-playback-error');
    };
    this._onError = () => {
      this.classList.remove('is-playing');
      this.setAttribute('data-playback-error', 'true');
    };

    this.video.addEventListener('playing', this._onPlaying);
    this.video.addEventListener('error', this._onError);

    if (typeof this._motionQuery.addEventListener === 'function') {
      this._motionQuery.addEventListener('change', this._onMotionChange);
    } else {
      this._motionQuery.addListener(this._onMotionChange);
    }

    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(
        (entries) => {
          this._isIntersecting = entries.some((entry) => entry.isIntersecting);
          this.syncPlayback();
        },
        { rootMargin: '200px 0px' }
      );
      this._observer.observe(this);
    } else {
      this._isIntersecting = true;
    }

    this.syncPlayback();
  }

  disconnectedCallback() {
    if (!this._connected) return;

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }

    if (typeof this._motionQuery.removeEventListener === 'function') {
      this._motionQuery.removeEventListener('change', this._onMotionChange);
    } else {
      this._motionQuery.removeListener(this._onMotionChange);
    }

    this.video.removeEventListener('playing', this._onPlaying);
    this.video.removeEventListener('error', this._onError);
    this.video.pause();
    this._isIntersecting = false;
    this._connected = false;
  }

  syncPlayback() {
    const motionReduced = this._motionQuery.matches;
    if (motionReduced) {
      this.setAttribute('data-motion-reduced', 'true');
    } else {
      this.removeAttribute('data-motion-reduced');
    }

    if (motionReduced) {
      this.classList.remove('is-playing');
    }

    if (motionReduced || !this._isIntersecting) {
      this.video.pause();
      return;
    }

    const playback = this.video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch((error) => {
        if (error.name === 'AbortError') return;

        this.classList.remove('is-playing');
        this.setAttribute('data-playback-error', 'true');
        console.warn('Del Sol Manifesto video playback failed.', error);
      });
    }
  }
}

if (!customElements.get('delsol-manifesto')) {
  customElements.define('delsol-manifesto', DelSolManifesto);
}
